import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["redirectTo", "children"];
import React from 'react';
import { node, string } from 'prop-types';
import { Redirect, Route, useLocation } from 'react-router-dom';
import { useUserContext } from '@magento/peregrine/lib/context/user';

var AuthRoute = function AuthRoute(props) {
  var redirectTo = props.redirectTo,
      children = props.children,
      rest = _objectWithoutProperties(props, _excluded);

  var _useLocation = useLocation(),
      pathname = _useLocation.pathname;

  var _useUserContext = useUserContext(),
      _useUserContext2 = _slicedToArray(_useUserContext, 1),
      isSignedIn = _useUserContext2[0].isSignedIn;

  if (!isSignedIn) {
    return React.createElement(Redirect, {
      to: {
        pathname: redirectTo,
        // Keep path in memory to redirect user there when signed in
        state: {
          from: pathname
        }
      }
    });
  }

  return React.createElement(Route, rest, children);
};

AuthRoute.defaultProps = {
  redirectTo: '/'
};
AuthRoute.propTypes = {
  redirectTo: string,
  children: node
};
export default AuthRoute;